module.exports = __webpack_public_path__ + "d3ee4f3c24f31a28b152778396ff7cfa.svg";